import React, { useEffect, useState } from "react";
import fetchMSSQLHook from "../../../hooks/fetchMSSQL-hook";
import InfoToast from "../../../util/InfoToast";

const UsersForm = ({ handleSubmit, handleClose, miniData, warning, form }) => {
    const { fetchMssqlApi } = fetchMSSQLHook();
    const isNew = form === "new";

    const [roles, setRoles] = useState([]);
    const [warehouses, setWarehouses] = useState([]);
    const [locations, setLocations] = useState([]);
    const [locationsList, setLocationsList] = useState([]);
    const [newLocation, setNewLocation] = useState("");
    const [isActive, setIsActive] = useState(!!miniData?.IsActive);

    const infoText = "W przypadku gdy użytkownik nie ma przypisanej żadnej lokalizacji ma dostęp do wszystkich automatów. Po przypisaniu pierwszej i kolejnych lokalizacji ogranicza mu się dostęp do automatów w wybranych lokalizacjach";

    useEffect(() => {
        document.body.classList.add("modal-open");
        fetchMssqlApi("roles", {}, res => setRoles((res || []).map(x => x.Name)));
        fetchMssqlApi("warehouses", {}, res => setWarehouses((res || []).map(x => x.Name)));
        fetchMssqlApi("locations", {}, res => setLocationsList(res || []));

        if (miniData?.UserId) {
            fetchMssqlApi(`/user/location/${miniData.UserId}`, {}, res => setLocations(res?.userLocations || []));
        }

        return () => document.body.classList.remove("modal-open");
    }, [miniData?.UserId]);

    const addLocation = evt => {
        evt.preventDefault();

        const location = locationsList.find(x => x.Name === newLocation);
        if (!location) return setNewLocation("");

        const existing = locations.find(x => Number(x.LocationId) === Number(location.LocationId));

        if (existing) {
            setLocations(prev => prev.map(x => Number(x.LocationId) === Number(location.LocationId) ? { ...x, IsDeleted: false } : x));
        } else {
            setLocations(prev => [...prev, {
                LocationId: location.LocationId,
                Name: location.Name,
                UserLocationId: `new-${location.LocationId}-${Date.now()}`,
                IsNew: true,
                IsDeleted: false
            }]);
        }

        setNewLocation("");
    };

    const deleteLocation = id => {
        setLocations(prev => prev.map(x => String(x.UserLocationId) === String(id) ? { ...x, IsDeleted: true } : x));
    };

    const visibleLocations = locations.filter(x => !x.IsDeleted);

    return (
        <>
            <div className="modal-backdrop fade show" />

            <div
                className="modal fade show d-block"
                role="dialog"
                tabIndex="-1"
                onMouseDown={evt => evt.target === evt.currentTarget && handleClose()}
            >
                <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">

                        <div className="modal-header">
                            <h5 className="modal-title">{isNew ? "Dodaj użytkownika" : "Edytuj użytkownika"}</h5>
                            <button type="button" className="close" onClick={handleClose}>
                                <span>&times;</span>
                            </button>
                        </div>

                        <div className="modal-body">
                            {warning?.status && <div className="alert alert-danger text-center">{warning.message}</div>}

                            <form id="modal-form" autoComplete="off" onSubmit={evt => handleSubmit(evt, locations)}>
                                <input type="hidden" name="userId" value={miniData?.UserId || ""} />
                                <input type="hidden" name="isActive" value={isActive ? "1" : "0"} />

                                <div className="form-group">
                                    <label className="h6">Nazwa</label>
                                    <input className="form-control" name="name" defaultValue={miniData?.Name || ""} required />
                                </div>

                                <div className="form-group">
                                    <label className="h6">Email</label>
                                    <input className="form-control" name="email" type="email" defaultValue={miniData?.Email || ""} required />
                                </div>

                                <div className="form-group">
                                    <label className="h6">Magazyn</label>
                                    <input className="form-control" name="warehouse" list="warehouses" defaultValue={miniData?.WarehousName || ""} />
                                    <datalist id="warehouses">{warehouses.map(x => <option key={x} value={x} />)}</datalist>
                                </div>

                                <div className="form-group">
                                    <label className="h6">Rola</label>
                                    <input className="form-control" name="role" list="roles" defaultValue={miniData?.Role || ""} />
                                    <datalist id="roles">{roles.map(x => <option key={x} value={x} />)}</datalist>
                                </div>

                                <hr />

                                {isNew ? (
                                    <div className="form-group">
                                        <label className="h6">Hasło</label>
                                        <input className="form-control" name="password" type="password" minLength={6} required autoComplete="new-password" />
                                    </div>
                                ) : (
                                    <>
                                        <div className="form-group">
                                            <label className="h6">Wpisz nowe hasło</label>
                                            <input className="form-control" name="newPassword" type="password" minLength={6} autoComplete="new-password" />
                                        </div>

                                        <div className="form-group">
                                            <label className="h6">Powtórz nowe hasło</label>
                                            <input className="form-control" name="newPasswordRepeat" type="password" minLength={6} autoComplete="new-password" />
                                        </div>

                                        <hr />

                                        <div className="d-flex justify-content-between align-items-end mb-1">
                                            <label className="h6 mb-0">Przypisz lokalizację</label>
                                            <InfoToast text={infoText} delay={10000} btnSize="sm" leftDistance="19%" />
                                        </div>

                                        <div className="input-group mb-2">
                                            <input
                                                className="form-control"
                                                list="locations"
                                                value={newLocation}
                                                onChange={evt => setNewLocation(evt.target.value)}
                                            />

                                            <datalist id="locations">
                                                {locationsList
                                                    .filter(x => !visibleLocations.some(y => Number(y.LocationId) === Number(x.LocationId)))
                                                    .map(x => <option key={x.LocationId} value={x.Name} />)}
                                            </datalist>

                                            <div className="input-group-append">
                                                <button type="button" className="btn btn-outline-success" disabled={!newLocation} onClick={addLocation}>
                                                    <i className="fa fa-plus" />
                                                </button>
                                            </div>
                                        </div>

                                        {!!visibleLocations.length && (
                                            <table className="table table-striped table-sm mt-3">
                                                <tbody>
                                                    {visibleLocations.map(location => (
                                                        <tr key={location.UserLocationId}>
                                                            <td className="align-middle">{location.Name}</td>
                                                            <td className="text-right">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-outline-danger"
                                                                    onClick={() => deleteLocation(location.UserLocationId)}
                                                                >
                                                                    <i className="fa fa-trash" />
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        )}
                                    </>
                                )}
                            </form>
                        </div>

                        <div className="modal-footer justify-content-between">
                            <div>
                                {!isNew && (
                                    <button
                                        type="button"
                                        disabled={!miniData?.IsEditable}
                                        className={`btn ${isActive ? "btn-outline-danger" : "btn-outline-success"}`}
                                        onClick={() => setIsActive(prev => !prev)}
                                    >
                                        {isActive ? "Dezaktywuj" : "Aktywuj"}
                                    </button>
                                )}
                            </div>

                            <div>
                                <button type="button" className="btn btn-secondary mr-2" onClick={handleClose}>Anuluj</button>
                                <button type="submit" form="modal-form" className="btn btn-primary">{isNew ? "Dodaj" : "Zapisz"}</button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};

export default UsersForm;